<div class="container-fluid banner">
    <img src="../../assets/doctor-landing.jpg" class="img-responsive" style="width: 100%;">
   
    
    <div class="top-left">
        <h1>The Best Ayurvedic Doctors<br>Are Just a Call Away </h1>
        <button class="btn2" *ngIf="getToken"><a routerLink="/request-on-appointment">Consult Now</a></button>
        <button class="btn2" *ngIf="!getToken" routerLink='/login'>Consult Now</button>
    </div>
   
  </div>

  <div class="container">
      <h2>{{brandData?.brandName}}’s Ayurvedic Specialists Offer Best-in-class Personalised Care</h2>
      <p>{{brandData?.brandName}}’s virtual gateway to specialised Ayurvedic care is just a click away. {{brandData?.brandName}} provides wellness consultations and natural ayurvedic treatment from the very best. Just schedule an appointment and be on your way to better health.
    </p>
    <p>Our consultations are open not just for those with health conditions but also for those who want to improve their lifestyle choices. So, if you want the science of life to help you provide better health for you and your family, just connect with us right here. 
    </p>
  </div>

<div class="container car">
    <div id="carousel-example-generic" class="carousel slide">
        <!-- Indicators -->
        <!-- <ol class="carousel-indicators">
          <li data-target="#carousel-example-generic" data-slide-to="0" class="active"></li>
          <li data-target="#carousel-example-generic" data-slide-to="1"></li>
          <li data-target="#carousel-example-generic" data-slide-to="2"></li>
        <li data-target="#carousel-example-generic" data-slide-to="3"></li>
        </ol> -->
      
        <!-- Wrapper for slides -->
        <div class="carousel-inner">
             <!-- Slide -->
          <div class="item active">
              <div class="row">
                  <div class="col-sm-2 col-xs-6 hc-icons">
                      <img src="assets/hc-1.png" alt=""/>
                      <figcaption>Cardiovascula</figcaption>
                    
                  </div>
                  <div class="col-sm-2 col-xs-6 hc-icons">
                    <img src="assets/hc-2.png" alt=""/>
                    <figcaption>Auto-Immune</figcaption>
                    
                  </div>
                  <div class="col-sm-2 col-xs-6 hc-icons">
                    <img src="assets/hc-3.png" alt=""/>
                    <figcaption>Gastrointestinal</figcaption>
                    
                  </div>
                  <div class="col-sm-2 col-xs-6 hc-icons">
                    <img src="assets/hc-4.png" alt=""/>
                    <figcaption>Endocrine</figcaption>
                    
                  </div>
                  <div class="col-sm-2 col-xs-6 hc-icons">
                    <img src="assets/hc-5.png" alt=""/>
                    <figcaption>ENT</figcaption>
                     
                  </div>
                  <div class="col-sm-2 col-xs-6 hc-icons">
                    <img src="assets/hc-6.png" alt=""/>
                    <figcaption>Endocrine</figcaption>
                     
                  </div>
              </div>
          </div>
             <!-- Slide -->
          <div class="item">
            <div class="row">
                <div class="col-sm-2 col-xs-6">
                    <img src="assets/hc-1.png" alt=""/>
                    <figcaption>Cardiovascula</figcaption>
                  
                </div>
                <div class="col-sm-2 col-xs-6">
                  <img src="assets/hc-2.png" alt=""/>
                  <figcaption>Auto-Immune</figcaption>
                  
                </div>
                <div class="col-sm-2 col-xs-6">
                  <img src="assets/hc-3.png" alt=""/>
                  <figcaption>Gastrointestinal</figcaption>
                  
                </div>
                <div class="col-sm-2 col-xs-6">
                  <img src="assets/hc-4.png" alt=""/>
                  <figcaption>Endocrine</figcaption>
                  
                </div>
                <div class="col-sm-2 col-xs-6">
                  <img src="assets/hc-5.png" alt=""/>
                  <figcaption>ENT</figcaption>
                   
                </div>
                <div class="col-sm-2 col-xs-6">
                  <img src="assets/hc-6.png" alt=""/>
                  <figcaption>Endocrine</figcaption>
                   
                </div>
            </div>
          </div>
             <!-- Slide -->
          <div class="item">
            <div class="row">
                <div class="col-sm-2 col-xs-6">
                    <img src="assets/hc-1.png" alt=""/>
                    <figcaption>Cardiovascula</figcaption>
                  
                </div>
                <div class="col-sm-2 col-xs-6">
                  <img src="assets/hc-2.png" alt=""/>
                  <figcaption>Auto-Immune</figcaption>
                  
                </div>
                <div class="col-sm-2 col-xs-6">
                  <img src="assets/hc-3.png" alt=""/>
                  <figcaption>Gastrointestinal</figcaption>
                  
                </div>
                <div class="col-sm-2 col-xs-6">
                  <img src="assets/hc-4.png" alt=""/>
                  <figcaption>Endocrine</figcaption>
                  
                </div>
                <div class="col-sm-2 col-xs-6">
                  <img src="assets/hc-5.png" alt=""/>
                  <figcaption>ENT</figcaption>
                   
                </div>
                <div class="col-sm-2 col-xs-6">
                  <img src="assets/hc-6.png" alt=""/>
                  <figcaption>Endocrine</figcaption>
                   
                </div>
            </div>
          </div>
      
      </div>
        <!-- Controls -->
        <a class="left carousel-control" href="#carousel-example-generic" data-slide="prev">
          <span class="icon-prev"></span>
        </a>
        <a class="right carousel-control" href="#carousel-example-generic" data-slide="next">
          <span class="icon-next"></span>
        </a>
</div>
</div>
  <div class="container">
      <div class="row">
      <div class="col-lg-6 col-md-6 col-xs-12 col-sm-12 box">
      <h3>Our Medical Team</h3>
      <p>Our team of Ayurvedic doctors offer you expert guidance depending on the urgency of your situation and health care needs. They have the expertise to assess and treat acute and chronic health conditions through the life science of Ayurveda. Our medical team understand the significance of a balanced mind and body and go the extra mile to help you achieve optimum health. At {{brandData?.brandName}}, we strive to touch as many lives as possible. Connect with us to enjoy the gift of holistic health and overall well being.</p>
      <button class="btn" *ngIf="getToken" routerLink="/request-on-appointment">Talk to a Doctor</button>
      <button class="btn" *ngIf="!getToken" routerLink='/login'>Talk to a Doctor</button>
     
    </div>
    <div class="col-lg-6 col-md-6 col-xs-12 col-sm-12 box2">
       <img src="assets/td-MedicalTeam.jpg">
      </div>
    </div>
  </div>

  <div class="container">
   <div class="row">
  <div class="col-lg-6 col-md-6 col-xs-12 col-sm-12">
     <img src="assets/td-expect.jpg">
    </div>
    <div class="col-lg-6 col-md-6 col-xs-12 col-sm-12 box3">
        <h3>What to Expect</h3>
       <p>At {{brandData?.brandName}} we take an indepth analysis of your health issues based on your health reports and lifestyle choices. After the assessment, our doctors give recommendations of Ayurvedic medications and treatment based on the individual’s health conditions. The right diet and excercises are part of the healing plan. In addition, the Ayurvedic doctor offers tips for changing your lifestyle choices. There can be follow-up sessions or the doctor may ask for an in-person consultation.</p>
      
       <button class="btn2 " *ngIf="getToken" routerLink="/request-on-appointment">Book an Appointment</button>
       <button class="btn2" *ngIf="!getToken" routerLink='/login'>Book an Appointment</button>
      </div>

    </div>
</div>
<div class="container">
    <div class="col-lg-8 col-md-8 col-xs-12">
    <h3>The Process</h3>
    <ul>
        <li><i class="glyphicon glyphicon-arrow-right"></i>Register with us by filling out the online form.</li>
        <li><i class="glyphicon glyphicon-arrow-right"></i>Mention your health issues and for what you are consulting.</li>
        <li><i class="glyphicon glyphicon-arrow-right"></i>Let us know whether you are consulting for yourself or for anyone else.</li>
        <li><i class="glyphicon glyphicon-arrow-right"></i>Choose the language you prefer to interact with the Ayurvedic doctor online.</li>
        <li><i class="glyphicon glyphicon-arrow-right"></i>Request for the Ayurvedic doctor of your choice or pick from the recommendations listed.</li>
        <li><i class="glyphicon glyphicon-arrow-right"></i>Schedule an appointment; you can choose to wait online and check with a doctor immediately or opt for future consultation.
        </li>
        <li><i class="glyphicon glyphicon-arrow-right"></i>You can choose either audio or video consultation, whichever suits you best.</li>
        <li><i class="glyphicon glyphicon-arrow-right"></i>Ensure you have all the necessary information and past reports that are needed for the consultation
        </li>
        <li><i class="glyphicon glyphicon-arrow-right"></i>Connect with a doctor and, if needed, schedule an appointment for future follow-ups right away. 
        </li>
    </ul>
    <button class=" btn2"  *ngIf="getToken"><a routerLink="/request-on-appointment">SCHEDULE A CONSULTATION</a></button>
    <button class="btn2" *ngIf="!getToken" routerLink='/login'>SCHEDULE A CONSULTATION</button>
</div>

<div class="col-lg-4 col-md-4 col-xs-12 box4">
    <div class="row">
        <h4>Online Ayurvedic Consultation In A Snap</h4>
        <p>Find the right ayurvedic doctor near you, anytime and anywhere!
        </p>
    </div>
<div class="row">
    <div class="col-lg-4 col-md-4 col-xs-4">
        
        <h6>Step1</h6>
        <h6>Step2</h6>
        <h6>Step3</h6>
    </div>
    <div class="col-lg-3 col-md-3 col-xs-3">
        <img src="assets/td-step1.png" >
        <img src="assets/td-step2.png">
        <img src="assets/td-step3.png">
    </div>
    <div class="col-lg-5 col-md-5 col-xs-5">
        <h5>Register with Us</h5>
        <h5>Schedule an Appointment</h5>
        <h5>Consult Online</h5>
    </div>

    
</div>
</div>